const PublicationModule = resolve =>
  require(['src/views/publication/PublicationModule'], resolve)
const PublicationPublishManage = resolve =>
  require(['src/views/publication/PublicationPublishManage'], resolve)
const PodcastPublication = resolve =>
  require(['src/views/publication/PodcastPublication'], resolve)
const Resource = resolve =>
  require(['src/views/resource/ResourceManage'], resolve)
const MagazineModule = resolve =>
  require(['src/views/magazine/MagazineModule.vue'], resolve)
const MagazineCreate = resolve =>
  require(['src/views/magazine/MagazineCreate.vue'], resolve)
const MagazineManage = resolve =>
  require(['src/views/magazine/MagazineManage.vue'], resolve)
const MagazineBasicManage = resolve =>
  require(['src/views/magazine/MagazineBasicManage.vue'], resolve)
const MagazineContentManage = resolve =>
  require(['src/views/magazine/MagazineContentManage.vue'], resolve)
const PodcastComment = resolve =>
  require(['src/views/podcast/PodcastComment.vue'], resolve)
const PublicationPageManage = resolve =>
  require(['src/views/page/PageManage'], resolve)
const PromotionPage = resolve =>
  require(['src/views/promotion/promotion'], resolve)
const ReportPage = resolve => require(['src/views/report/report'], resolve)
const PushModule = resolve =>
  require(['src/views/push/PushModule.vue'], resolve)
const TopicManage = resolve => require(['src/views/topic/TopicManage'], resolve)
const PushPage = resolve => require(['src/views/push/push.vue'], resolve)
const PushNewPage = resolve => require(['src/views/push/pushNew.vue'], resolve)
const SettingPage = resolve => require(['src/views/setting/Setting'], resolve)
const ThemePage = resolve => require(['src/views/theme/ThemePage.vue'], resolve)

const podcastPublicationRouter = {
  path: '/podcast/:publicationId',
  component: PublicationModule,
  children: [
    {
      name: 'Podcast页面',
      path: '/podcast/:publicationId/page',
      component: PublicationPageManage,
    },
    {
      name: 'Podcast素材库',
      path: '/podcast/:publicationId/resource',
      component: Resource,
    },
    {
      name: 'Podcast关于',
      path: '/podcast/:publicationId/about',
      component: PodcastPublication,
    },
    {
      name: 'Podcast首页',
      path: '/podcast/:publicationId/show',
      redirect: '/podcast/:publicationId/',
    },
    {
      name: 'Podcast节目',
      path: '/podcast/:publicationId/',
      component: PodcastPublication,
    },
    {
      name: 'Podcast社群',
      path: '/podcast/:publicationId/topic',
      component: TopicManage,
    },
    // 笔记管理
    {
      name: 'Podcast笔记管理',
      path: '/podcast/:publicationId/comment',
      component: PodcastComment,
    },
    {
      name: 'Podcast创建栏目',
      path: '/podcast/:publicationId/magazine/create',
      component: MagazineCreate,
    },
    {
      name: 'Podcast发布',
      path: '/podcast/:publicationId/publish',
      component: PublicationPublishManage,
    },
    {
      path: '/podcast/:publicationId/magazine/:magazineId',
      component: MagazineModule,
      children: [
        {
          name: 'Podcast文章',
          path: '/podcast/:publicationId/magazine/:magazineId/',
          component: MagazineManage,
        },
        {
          name: 'Podcast文章管理',
          path: '/podcast/:publicationId/magazine/:magazineId/article',
          component: MagazineManage,
        },
        {
          name: 'Podcast主编管理',
          path: '/podcast/:publicationId/magazine/:magazineId/contributor',
          component: MagazineManage,
        },
        {
          name: 'Podcast推广杂志',
          path: '/podcast/:publicationId/magazine/:magazineId/promotion',
          component: MagazineManage,
        },
        {
          name: 'Podcast配置杂志',
          path: '/podcast/:publicationId/magazine/:magazineId/config',
          component: MagazineManage,
        },
        {
          name: 'Podcast编辑杂志',
          path: '/podcast/:publicationId/magazine/:magazineId/edit',
          component: MagazineBasicManage,
        },
        {
          name: 'Podcast内容管理',
          path: '/podcast/:publicationId/magazine/:magazineId/content',
          component: MagazineContentManage,
        },
      ],
    },
    {
      name: 'Podcast主题',
      path: '/podcast/:publicationId/theme',
      component: ThemePage,
    },
    {
      name: 'Podcast分析',
      path: '/podcast/:publicationId/report',
      component: ReportPage,
    },
    {
      name: 'Podcast推广',
      path: '/podcast/:publicationId/promotion',
      component: PromotionPage,
    },
    {
      name: 'Podcast推送',
      path: '/podcast/:publicationId/push',
      component: PushModule,
      children: [
        {
          name: 'PodcastPush',
          path: '/podcast/:publicationId/push/',
          component: PushPage,
        },
        {
          name: 'Podcast新建',
          path: '/podcast/:publicationId/push/new',
          component: PushNewPage,
        },
      ],
    },
    {
      name: 'Podcast栏目设置',
      path: '/podcast/:publicationId/setting',
      component: SettingPage,
    },
  ],
}

export default podcastPublicationRouter
